import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import { apiConfig } from '../../api/ApiConfig'

const { verifySessionToken, logoutSession } = apiConfig()

export const checkAuthStatus = createAsyncThunk("auth/checkStatus", async (_, { getState }) => {
  try {
    const state = getState();
    if (localStorage.getItem('mock_admin_auth') === 'true' || (state.auth && state.auth.isAuthenticated && state.auth.userId === 'admin')) {
      return { validSession: true, userId: 'admin' };
    }
    const data = await verifySessionToken();
    console.log('verifying session token:', data);
    return data;
  } catch (error) {
    if (localStorage.getItem('mock_admin_auth') === 'true') {
      return { validSession: true, userId: 'admin' };
    }
    console.error('Error verifying session token:', error)
    return { validSession: false, userId: null };
  }
});

export const logoutAuthSession = createAsyncThunk("auth/logoutSession", async () => {
  localStorage.removeItem('mock_admin_auth')
  try {
    await logoutSession();
  } catch (error) {
    console.error('Error logout session token:', error)
  }
  return { isAuthenticated: false, userId: null, token: null };
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: false,
    token: null,
    userId: null,
    error: null,
    isTokenAuth: false,
  },
  reducers: {
    setAuthentication: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated
      state.token = action.payload.token
      state.userId = action.payload.userId
      state.error = action.payload.error
      state.isTokenAuth = action.payload.isTokenAuth || false
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.isTokenAuth = false
      state.userId = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(checkAuthStatus.fulfilled, (state, action) => {
      state.isAuthenticated = action.payload.validSession;
      state.userId = action.payload.userId;
    });
    builder.addCase(logoutAuthSession.fulfilled, (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.token = action.payload.token;
      state.userId = action.payload.userId;
    });
  },
})

export const { setAuthentication, logout } = authSlice.actions
export default authSlice.reducer
